var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoor2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 41,
    viewBox: "0 0 30 41",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8511 0H7.14894C5.74468 0 4.59575 1.13335 4.59575 2.51855V39.0376H0.638298C0.255319 39.0376 0 39.2895 0 39.6672C0 40.045 0.255319 40.2969 0.638298 40.2969C13.4681 40.2969 16.9787 40.2969 29.3617 40.2969C29.7447 40.2969 30 40.045 30 39.6672C30 39.2895 29.7447 39.0376 29.3617 39.0376H25.4043V2.51855C25.4043 1.13335 24.2553 0 22.8511 0ZM5.87234 39.0376V2.51855C5.87234 1.82595 6.44681 1.25928 7.14894 1.25928H22.8511C23.5532 1.25928 24.1277 1.82595 24.1277 2.51855V39.0376H5.87234Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8936 4.53215C19.7234 3.5877 17.3617 3.08398 15.0638 3.08398C15.0638 3.08398 15.0638 3.08398 15 3.08398C15 3.08398 15 3.08398 14.9362 3.08398C12.6383 3.08398 10.2766 3.5877 8.10637 4.53215C7.85105 4.65808 7.72339 4.84697 7.72339 5.09883V28.3325C7.72339 28.7732 8.1702 29.0881 8.55318 28.8992C12.7021 27.388 17.234 27.388 21.383 28.8992C21.7659 29.0251 22.2127 28.7732 22.2127 28.3325V5.09883C22.2766 4.84697 22.1489 4.65808 21.8936 4.53215ZM8.99998 5.53958C10.7234 4.84697 12.5106 4.46919 14.3617 4.34326V26.5065C12.5745 26.5695 10.7234 26.8843 8.99998 27.388V5.53958ZM21 27.451C19.2766 26.8843 17.4893 26.6325 15.6383 26.5695V4.34326C17.4255 4.40623 19.2766 4.78401 21 5.53958V27.451Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8936 31.0411C17.4893 29.0892 12.5106 29.0892 8.10637 31.0411C7.85105 31.167 7.72339 31.3559 7.72339 31.6077V36.5189C7.72339 36.8967 7.97871 37.1486 8.36169 37.1486H21.6383C22.0213 37.1486 22.2766 36.8967 22.2766 36.5189V31.6077C22.2766 31.4188 22.1489 31.167 21.8936 31.0411ZM21 35.9522H8.99998V32.0485C12.8298 30.4744 17.1064 30.4744 21 32.0485V35.9522Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 38.604,
    y2: 28.7397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 7.72339,
    y1: 3.08398,
    x2: 29.7957,
    y2: 15.4597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.72339,
    y1: 29.5771,
    x2: 13.9234,
    y2: 41.4944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoor2);
export default __webpack_public_path__ + "static/media/icon-door2.f8bb8e6b3d72eaec251ad1c0dd2d3742.svg";
export { ForwardRef as ReactComponent };